import React, { useEffect } from 'react'
import MasterLayout from '../components/layouts/MasterLayout'
import MainSearch from '../components/search/MainSearch'
import CollectionActiveTab from '../components/products/CollectionActiveTab'
import { useSelector } from 'react-redux'
import SingleCollectionBanner from '../components/products/SingleCollectionBanner'

const ShowSingleCollectionPage = () => {

    const singleBannerData = useSelector((state) => state.banner.singleBannerData)

    return (
        <MasterLayout>
            <SingleCollectionBanner title={singleBannerData?.name} imgUrl={singleBannerData?.image} />
            <CollectionActiveTab fileCategories={singleBannerData?.fileCategories} collectionId={singleBannerData?.id}/>
        </MasterLayout>
    )
}

export default ShowSingleCollectionPage
